var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCenterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 35,
    viewBox: "0 0 31 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.9463 6.99001C29.1429 4.8538 26.8405 3.19531 24.243 2.16146C21.6455 1.12761 18.8331 0.750305 16.055 1.06297C13.2769 1.37564 10.6188 2.36863 8.31605 3.95398C6.01335 5.53933 4.13717 7.6681 2.8537 10.1517C1.57023 12.6354 0.91909 15.3972 0.957949 18.1926C0.996808 20.988 1.72447 23.7307 3.07648 26.1777C4.42849 28.6247 6.36312 30.7005 8.709 32.2212C11.0549 33.7419 13.7396 34.6607 16.5253 34.896L17.1776 27.1748C15.6616 27.0467 14.2006 26.5468 12.924 25.7192C11.6474 24.8916 10.5945 23.762 9.85878 22.4303C9.12302 21.0987 8.72703 19.6061 8.70588 18.0849C8.68474 16.5637 9.03909 15.0607 9.73755 13.7091C10.436 12.3575 11.457 11.1991 12.7101 10.3363C13.9632 9.47358 15.4098 8.9332 16.9216 8.76304C18.4335 8.59289 19.964 8.79822 21.3775 9.36083C22.791 9.92345 24.044 10.826 25.0254 11.9885L30.9463 6.99001Z",
    fill: "url(#paint0_linear_765_5072)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_765_5072",
    x1: 6.99,
    y1: 4.96631,
    x2: 28.9226,
    y2: 30.9463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792284,
    stopColor: "#FDFEFF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterIcon);
export default __webpack_public_path__ + "static/media/centerIcon.c447cb37c58f3e12fb59f45e55aa45ad.svg";
export { ForwardRef as ReactComponent };